import React from 'react'
import { X } from 'lucide-react'
import EvidenceLinkBrowser from '../../../components/EvidenceLinkBrowser'

/** Pick one floor row for an observation — does not link until observation is saved. */
export default function FloorActivityPickerModal({
  isOpen,
  onClose,
  caseId,
  onPick,
  defaultMemberNumber = '',
  defaultEgmHouseNo = '',
  defaultTradingDay = '',
}) {
  if (!isOpen || !caseId) return null

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 bg-black/45" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-5xl max-h-[92vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 shrink-0">
          <div>
            <div className="text-sm font-semibold text-slate-800">Select floor activity</div>
            <div className="text-xs text-slate-500">Choose a session, interval, or payout to attach when you save the observation.</div>
          </div>
          <button type="button" onClick={onClose} className="p-1 rounded hover:bg-slate-100">
            <X size={18} className="text-slate-500" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          <EvidenceLinkBrowser
            display="embedded"
            isOpen
            pickMode
            onPick={(row) => {
              onPick?.(Array.isArray(row) ? row[0] : row)
              onClose?.()
            }}
            onClose={onClose}
            context={{ type: 'investigation_case', id: caseId }}
            defaultMemberNumber={defaultMemberNumber}
            defaultEgmHouseNo={defaultEgmHouseNo}
            defaultTradingDay={defaultTradingDay}
            defaultLane="combined"
            defaultCombinedView="interval"
            title="Select floor activity"
            lanes={['combined', 'payouts']}
          />
        </div>
      </div>
    </div>
  )
}
